import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  PLATE_PRODUCTION_EXPORT_HEADERS,
  buildPlateProductionExportRows,
} from "./plateProductionExportHelpers";

export const generatePlateProductionPDF = (responseData) => {
  const tableData = buildPlateProductionExportRows(responseData);

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  doc.setFontSize(16);
  doc.setFont(undefined, "bold");
  doc.text("Plate Production Report", 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  const d = new Date();
  const generatedAt =
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0");
  doc.text(`Generated: ${generatedAt}`, 14, 22);

  autoTable(doc, {
    startY: 28,
    head: [
      [
        {
          content: "Plate Production",
          colSpan: 3,
          styles: {
            fillColor: [68, 114, 196],
            halign: "center",
            fontStyle: "bold",
            textColor: [255, 255, 255],
          },
        },
        {
          content: "Plate Details",
          colSpan: 11,
          styles: {
            fillColor: [68, 114, 196],
            halign: "center",
            fontStyle: "bold",
            textColor: [255, 255, 255],
          },
        },
      ],
      PLATE_PRODUCTION_EXPORT_HEADERS,
    ],
    body: tableData,
    styles: {
      fontSize: 6,
      cellPadding: 1.5,
      lineColor: [200, 200, 200],
      lineWidth: 0.1,
      valign: "top",
    },
    headStyles: {
      fillColor: [217, 225, 242],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      fontSize: 7,
      halign: "center",
    },
    margin: { top: 28, left: 6, right: 6 },
  });

  return doc;
};

export const downloadPlateProductionPDF = (
  productionData,
  filename = "plate_production_report.pdf",
) => {
  const doc = generatePlateProductionPDF(productionData);
  doc.save(filename);
};
